module.exports = __webpack_public_path__ + "img/background17.be994c01.jpg";